/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { pushTypeEnumSchema } from "../pushTypeEnumSchema.ts";
import { z } from "zod";

export const postApiTestPushQueryParamsSchema = z.object({
    "Id": z.string().uuid(),
"Type": z.lazy(() => pushTypeEnumSchema).describe("<p>Возможные значения:</p>\n<ul>\n<li><b>1 - Message</b>: Сообщение</li>\n<li><b>2 - Notification</b>: Уведомление</li>\n<li><b>3 - Radio</b>: Прямой эфир</li>\n</ul>\n"),
"Title": z.string(),
"Body": z.string(),
"ImageUrl": z.string().optional(),
"deviceIds": z.array(z.string()).optional()
    })

/**
 * @description Успешно
 */
export const postApiTestPush200Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const postApiTestPush400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const postApiTestPush401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const postApiTestPush403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const postApiTestPush500Schema = z.lazy(() => badResponseModelSchema)

export const postApiTestPushMutationResponseSchema = z.lazy(() => postApiTestPush200Schema)